import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "vil-barchart--invalid"
}
const _hoisted_2 = {
  key: 2,
  class: "vil-barchart--rendering"
}

import { ref } from "vue";
import { watch } from "vue";

import { onBeforeMount } from "vue";

import { Bar } from "vue-chartjs";
// import { Line } from "vue-chartjs";

import { Title } from "chart.js";
import { Legend } from "chart.js";
import { Tooltip } from "chart.js";
import { LinearScale } from "chart.js";
import { TimeScale } from "chart.js";
import { LineElement } from "chart.js";
import { PointElement } from "chart.js";
import { CategoryScale } from "chart.js";
import { Chart as ChartJS } from "chart.js";

import { fatArrow } from "./plugins/fatArrowBarChart";
// import { ObjectUtils } from "@/utils/object";
import { PX_CUSTOM_CHART_PLUGINS } from "./types";

import type { TChartData } from "vue-chartjs/dist/types";
import type { TChartOptions } from "vue-chartjs/dist/types";

type PxCustomChartPlugin = {
  id: PX_CUSTOM_CHART_PLUGINS;
  options: Record<string, any>;
};

enum PxCustomChartType {
  BAR = "bar",
  LINE = "line",
}


export default /*@__PURE__*/_defineComponent({
  __name: 'custom-bar-chart',
  props: {
    type: {},
    data: {},
    styles: {},
    options: {},
    plugins: {}
  },
  setup(__props: any) {

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  Title,
  Tooltip,
  Legend,
);

const props = __props;

/**
 * options: {
 *  barType: "ARROW", // ARROW | BLOCK,
 *  displayType: "NORMAL" // NORMAL | SEGRAGATED
 * }
 */
const pluginMap = {
  [PX_CUSTOM_CHART_PLUGINS.FAT_ARROW]: fatArrow,
};
const defaultStyles = { height: "530px" };
let defaultOptions: Record<string, any> = {
  responsive: true,
  animation: false,
  maintainAspectRatio: false,
  hover: {
    mode: "point",
    axis: "x",
    includeInvisible: true,
    intersect: true,
  },
  scales: {},
  plugins: {
    legend: {
      display: true,
      position: "bottom",
      labels: {
        pointStyle: "circle",
        usePointStyle: true,
      },
    },
  },
};

const chartState = ref("rendering");
const chartData = ref<any>({});
const chartStyles = ref({});
const chartPlugins = ref<any>([]);
const chartOptions = ref<any>();

const getPlugins = (plugin: PxCustomChartPlugin[]) => {
  const selectedPlugins = [];

  if (plugin) {
    for (const key in plugin) {
      selectedPlugins.push(pluginMap[plugin[key].id]);
    }
  }

  return selectedPlugins;
};

const initialize = () => {
  chartState.value = "rendering";

  if (!props.data) {
    chartState.value = "invalid";
    return;
  }

  chartData.value = props.data;
  chartStyles.value = defaultStyles;
  chartPlugins.value = getPlugins(props.plugins);

  if (props.plugins) {
    for (const plugin of props.plugins) {
      if (plugin.options) {
        defaultOptions.plugins[String(plugin.id)] = plugin.options;
      }
    }
  }

  if (props.options?.scales) {
    defaultOptions.scales = props.options.scales;
  }

  if (props.type === "bar") {
    chartOptions.value = defaultOptions as TChartOptions<"bar">;
  }
  if (props.type === "line") {
    chartOptions.value = defaultOptions as TChartOptions<"line">;
  }

  chartState.value = "ready";
};

onBeforeMount(initialize);
watch(() => props.data, initialize);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.type === 'bar' && chartState.value === 'ready')
      ? (_openBlock(), _createBlock(_unref(Bar), {
          key: 0,
          id: "my-chart-id-1",
          "chart-options": chartOptions.value,
          "chart-data": chartData.value,
          "chart-style": chartStyles.value,
          "inner-height": 600,
          plugins: chartPlugins.value
        }, null, 8, ["chart-options", "chart-data", "chart-style", "plugins"]))
      : _createCommentVNode("", true),
    (chartState.value === 'invalid')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("p", null, "Invalid Chart Data", -1)
        ]))]))
      : _createCommentVNode("", true),
    (chartState.value === 'rendering')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("p", null, "Rendering ...", -1)
        ]))]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})